const GooglePlay = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="140" height="50" viewBox="0 0 140 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4187_2987)">
        <g filter="url(#filter0_dddd_4187_2987)">
          <rect width="140" height="50" rx="4" fill="black" />
        </g>
        <path
          d="M46.92 18.18H48.76V19.62C48.29 19.98 47.64 20.19 47.06 20.19C45.68 20.19 44.52 18.99 44.52 17.56C44.52 16.14 45.68 14.94 47.06 14.94C47.77 14.94 48.58 15.26 49.05 15.77L49.76 15.09C49.11 14.42 48.03 14.01 47.06 14.01C45.13 14.01 43.48 15.63 43.48 17.56C43.48 19.49 45.13 21.12 47.06 21.12C48.03 21.12 49.11 20.7 49.76 20.04V17.3H46.92V18.18ZM53.5314 20.24C52.6414 20.24 52.0114 19.62 51.8814 18.76H55.9514C55.9514 16.91 55.0414 15.71 53.4614 15.71C52.0314 15.71 50.8814 16.85 50.8814 18.4C50.8814 19.99 52.1014 21.12 53.5414 21.12C54.2714 21.12 55.1714 20.81 55.6314 20.32L55.0114 19.68C54.7014 20 54.0714 20.24 53.5314 20.24ZM53.5014 16.59C54.3914 16.59 54.8814 17.17 54.9914 17.97H51.8914C52.0514 17.13 52.7014 16.59 53.5014 16.59ZM59.5189 20.07C59.4089 20.18 59.2089 20.26 58.9889 20.26C58.6989 20.26 58.4589 20 58.4589 19.64V16.67H59.6789V15.83H58.4589V14.41H57.4889V15.83H56.7089V16.67H57.4889V19.71C57.4889 20.54 58.0489 21.12 58.8489 21.12C59.2189 21.12 59.5989 20.98 59.8789 20.75L59.5189 20.07ZM64.2393 14.97C64.5593 14.97 64.8293 14.69 64.8293 14.37C64.8293 14.06 64.5593 13.78 64.2393 13.78C63.8993 13.78 63.6393 14.06 63.6393 14.37C63.6393 14.69 63.8993 14.97 64.2393 14.97ZM63.7393 21H64.7293V15.83H63.7393V21ZM68.5814 20.07C68.4714 20.18 68.2714 20.26 68.0514 20.26C67.7614 20.26 67.5214 20 67.5214 19.64V16.67H68.7414V15.83H67.5214V14.41H66.5514V15.83H65.7714V16.67H66.5514V19.71C66.5514 20.54 67.1114 21.12 67.9114 21.12C68.2814 21.12 68.6614 20.98 68.9414 20.75L68.5814 20.07ZM76.1418 21.12C78.0718 21.12 79.6918 19.49 79.6918 17.56C79.6918 15.63 78.0718 14.01 76.1418 14.01C74.2118 14.01 72.5718 15.63 72.5718 17.56C72.5718 19.49 74.2118 21.12 76.1418 21.12ZM76.1418 20.19C74.7718 20.19 73.6118 18.99 73.6118 17.56C73.6118 16.14 74.7718 14.94 76.1418 14.94C77.5118 14.94 78.6618 16.14 78.6618 17.56C78.6618 18.99 77.5118 20.19 76.1418 20.19ZM83.5277 15.71C82.8277 15.71 82.1977 16.07 81.8877 16.58V15.83H80.8977V21H81.8877V17.65C81.9677 17.04 82.5877 16.57 83.3077 16.57C84.0077 16.57 84.4977 17.11 84.4977 17.88V21H85.4677V17.71C85.4677 16.54 84.6677 15.71 83.5277 15.71Z"
          fill="white"
        />
        <path
          d="M48.362 30.206H50.602V31.676C50.056 32.068 49.384 32.292 48.726 32.292C47.088 32.292 45.702 30.864 45.702 29.184C45.702 27.518 47.088 26.09 48.726 26.09C49.608 26.09 50.546 26.51 51.12 27.168L52.618 25.824C51.652 24.816 50.168 24.214 48.726 24.214C45.94 24.214 43.574 26.482 43.574 29.184C43.574 31.886 45.94 34.168 48.726 34.168C50.168 34.168 51.652 33.566 52.618 32.558V28.596H48.362V30.206ZM57.8563 34.168C59.9983 34.168 61.7903 32.432 61.7903 30.374C61.7903 28.316 59.9983 26.594 57.8563 26.594C55.7003 26.594 53.8943 28.316 53.8943 30.374C53.8943 32.432 55.7003 34.168 57.8563 34.168ZM57.8563 32.446C56.7643 32.446 55.8543 31.494 55.8543 30.374C55.8543 29.254 56.7643 28.316 57.8563 28.316C58.9343 28.316 59.8443 29.254 59.8443 30.374C59.8443 31.494 58.9343 32.446 57.8563 32.446ZM66.7293 34.168C68.8713 34.168 70.6633 32.432 70.6633 30.374C70.6633 28.316 68.8713 26.594 66.7293 26.594C64.5733 26.594 62.7673 28.316 62.7673 30.374C62.7673 32.432 64.5733 34.168 66.7293 34.168ZM66.7293 32.446C65.6373 32.446 64.7273 31.494 64.7273 30.374C64.7273 29.254 65.6373 28.316 66.7293 28.316C67.8073 28.316 68.7173 29.254 68.7173 30.374C68.7173 31.494 67.8073 32.446 66.7293 32.446ZM77.2824 26.762V27.742C76.7924 27.056 75.8684 26.594 74.8884 26.594C73.0684 26.594 71.6824 28.008 71.6824 30.024C71.6824 32.04 73.0684 33.468 74.8884 33.468C75.8404 33.468 76.7084 33.048 77.2824 32.348V33.146C77.2824 34.084 76.4424 34.686 75.1264 34.686C74.2864 34.686 73.4464 34.42 72.9704 34L72.2564 35.442C72.9704 36.002 74.1744 36.408 75.4484 36.408C77.7304 36.408 79.3404 35.092 79.3404 33.23V26.762H77.2824ZM75.5324 31.746C74.5104 31.746 73.7824 31.032 73.7824 30.024C73.7824 29.016 74.5104 28.316 75.5324 28.316C76.5544 28.316 77.2824 29.016 77.2824 30.024C77.2824 31.032 76.5544 31.746 75.5324 31.746ZM81.1382 34H83.1822V24.214H81.1382V34ZM88.3823 32.362C87.5283 32.362 86.8983 31.83 86.6603 31.046H91.8823C91.8823 28.316 90.5523 26.594 88.2843 26.594C86.1703 26.594 84.5603 28.176 84.5603 30.36C84.5603 32.586 86.2403 34.168 88.3963 34.168C89.4603 34.168 90.7063 33.72 91.3503 33.048L90.0483 31.718C89.6563 32.096 88.9563 32.362 88.3823 32.362ZM88.3683 28.4C89.1943 28.4 89.7263 28.862 89.9223 29.576H86.6883C86.9543 28.848 87.5983 28.4 88.3683 28.4ZM97.2313 34H99.2893V30.878H101.557C103.643 30.878 105.183 29.534 105.183 27.63C105.183 25.726 103.643 24.382 101.557 24.382H97.2313V34ZM99.2893 28.988V26.272H101.333C102.355 26.272 103.055 26.804 103.055 27.63C103.055 28.456 102.355 28.988 101.333 28.988H99.2893ZM106.417 34H108.461V24.214H106.417V34ZM113.48 26.594C112.472 26.594 111.478 26.874 110.456 27.392L111.142 28.75C111.716 28.456 112.346 28.232 113.018 28.232C114.208 28.232 114.684 28.904 114.684 29.674V29.814C114.068 29.576 113.424 29.45 112.836 29.45C111.156 29.45 109.826 30.43 109.826 31.858C109.826 33.244 111.016 34.168 112.556 34.168C113.34 34.168 114.166 33.86 114.684 33.272V34H116.658V29.674C116.658 27.784 115.37 26.594 113.48 26.594ZM113.018 32.754C112.318 32.754 111.8 32.39 111.8 31.802C111.8 31.214 112.388 30.78 113.13 30.78C113.69 30.78 114.222 30.878 114.684 31.046V31.718C114.544 32.39 113.802 32.754 113.018 32.754ZM120.032 36.52C121.166 36.52 122.09 35.778 122.636 34.364L125.604 26.762H123.518L121.712 31.844L119.808 26.762H117.694L120.704 34.07L120.452 34.602C120.298 34.868 119.99 34.994 119.598 34.994C119.36 34.994 118.996 34.868 118.646 34.672L118.212 36.072C118.702 36.338 119.43 36.52 120.032 36.52Z"
          fill="white"
        />
        <g filter="url(#filter1_ii_4187_2987)">
          <path
            d="M13.463 12.3972C13.172 12.7052 13 13.1832 13 13.8022V35.9182C13 36.5382 13.172 37.0152 13.463 37.3232L13.537 37.3952L25.926 25.0062V24.8602V24.7142L13.537 12.3242L13.463 12.3972Z"
            fill="url(#paint0_linear_4187_2987)"
          />
          <path
            d="M30.0548 29.137L25.9258 25.006V24.86V24.714L30.0558 20.584L30.1488 20.637L35.0418 23.417C36.4388 24.211 36.4388 25.51 35.0418 26.305L30.1488 29.085L30.0548 29.137Z"
            fill="url(#paint1_linear_4187_2987)"
          />
          <g filter="url(#filter2_i_4187_2987)">
            <path
              d="M30.1489 29.0834L25.9249 24.8594L13.4629 37.3224C13.9229 37.8104 14.6839 37.8704 15.5409 37.3844L30.1489 29.0834Z"
              fill="url(#paint2_linear_4187_2987)"
            />
          </g>
          <path
            d="M30.1489 20.6361L15.5409 12.3361C14.6839 11.8491 13.9229 11.9101 13.4629 12.3981L25.9259 24.8611L30.1489 20.6361Z"
            fill="url(#paint3_linear_4187_2987)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dddd_4187_2987"
          x="-51"
          y="-18"
          width="242"
          height="152"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.4945" />
          <feGaussianBlur stdDeviation="1.15484" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0268173 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4187_2987" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.13211" />
          <feGaussianBlur stdDeviation="3.193" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0399899 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_4187_2987" result="effect2_dropShadow_4187_2987" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9.94853" />
          <feGaussianBlur stdDeviation="7.6875" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0582218 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_4187_2987" result="effect3_dropShadow_4187_2987" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="33" />
          <feGaussianBlur stdDeviation="25.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="effect3_dropShadow_4187_2987" result="effect4_dropShadow_4187_2987" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_4187_2987" result="shape" />
        </filter>
        <filter
          id="filter1_ii_4187_2987"
          x="13"
          y="12"
          width="23.0898"
          height="25.7207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4187_2987" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_innerShadow_4187_2987" result="effect2_innerShadow_4187_2987" />
        </filter>
        <filter
          id="filter2_i_4187_2987"
          x="13.4629"
          y="24.8594"
          width="16.6855"
          height="12.8613"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4187_2987" />
        </filter>
        <linearGradient
          id="paint0_linear_4187_2987"
          x1="24.8278"
          y1="13.5682"
          x2="8.0458"
          y2="30.3502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4187_2987"
          x1="36.8603"
          y1="24.86"
          x2="12.6644"
          y2="24.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4187_2987"
          x1="27.855"
          y1="27.1533"
          x2="5.09649"
          y2="49.9118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4187_2987"
          x1="10.3243"
          y1="5.03588"
          x2="20.4866"
          y2="15.1982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <clipPath id="clip0_4187_2987">
          <rect width="140" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GooglePlay
